import ActionButton from '@atoms/button';

import DNDBase from '@components/dnd/base';
import {
  SettingHeader,
  SettingsContainer,
  SettingsContent
} from '@components/ui/settings';

import useProcess from '@hooks/useProcess';
import { CircularProgress } from '@mui/joy';
import { observer } from 'mobx-react';
import { LoaderBox } from '@/components/ui/loader';

const GlobalVariables = () => {
  const process = useProcess();

  const globalVariablesDnd = process?.workflows[0]?.globalVariablesDnd;

  if (!process || process.isSmallProcess) {
    return (
      <LoaderBox>
        <CircularProgress />
      </LoaderBox>
    );
  }

  const onAddVariable = () => {
    if (!globalVariablesDnd) {
      return;
    }
    const window = globalVariablesDnd.createDndBlock(
      'GlobalVariable',
      'unrelevant'
    );

    const dropZonePath = 'root:root|0';
    const newState = globalVariablesDnd.insertBlockInState(
      dropZonePath,
      globalVariablesDnd.state,
      window
    );

    globalVariablesDnd.setState(newState);
  };

  return (
    <SettingsContainer>
      <SettingHeader
        description="Customize the big summary table where all trace are referenced"
        title="Global Variables"
      />
      {globalVariablesDnd && (
        <SettingsContent>
          <div className="title-body">
            <h3>Your global variables</h3>
            <ActionButton onClick={onAddVariable} value="Add a variable" />
          </div>
          <DNDBase dnd={globalVariablesDnd} />
        </SettingsContent>
      )}
    </SettingsContainer>
  );
};

export default observer(GlobalVariables);
